import React from "react";
import { Text, View } from "@react-pdf/renderer";

interface Defect {
    defect_id: string;
    label: string;
}
// #region Legacy Badges

interface LegacyDefectBadgeVectorProps {
    defect: Defect;
}

const LegacyDefectBadgeVector: React.FC<LegacyDefectBadgeVectorProps> = ({ defect }) => {
    return (
        <View style={{ backgroundColor: "#f0f0f0", paddingVertical: 1, paddingHorizontal: 3, borderRadius: 10, marginRight: 2, overflow: "hidden" }}>
            <Text style={{ fontSize: 7, paddingHorizontal: 2 }} wrap={false}>{defect.label}</Text>
        </View>
    );
};

interface LegacyDefectBadgesVectorProps {
    defects: Defect[];
}

export const LegacyDefectBadgesVector: React.FC<LegacyDefectBadgesVectorProps> = ({ defects }) => {
    if (defects.length === 0) {
        return <Text style={{ fontSize: 9 }}>-</Text>;
    }
    return <View style={{ maxWidth: 300, flexDirection: "row" }}>
        {defects.map((i) => <LegacyDefectBadgeVector key={i.defect_id} defect={i} />)}
    </View>;
};

// #endregion

export const DEFECT_SPLITTER = ",";

interface DefectBadgeVectorProps {
    defect: string;
}

const DefectBadgeVector: React.FC<DefectBadgeVectorProps> = ({ defect }) => {
    return (
        <View style={{ backgroundColor: "#f0f0f0", paddingVertical: 1, paddingHorizontal: 3, borderRadius: 10, marginRight: 2, overflow: "hidden" }}>
            <Text style={{ fontSize: 7, paddingHorizontal: 2 }} wrap={false}>{defect}</Text>
        </View>
    );
};

interface DefectBadgesVectorProps {
    defects: string;
}

export const DefectBadgesVector: React.FC<DefectBadgesVectorProps> = ({ defects: defectsAsString }) => {
    const defects = defectsAsString.split(DEFECT_SPLITTER);
    if (defects.length === 0) {
        return <Text style={{ fontSize: 9 }}>-</Text>;
    }
    return <View style={{ maxWidth: 300, flexDirection: "row" }}>
        {defects.map((defect, i) => <DefectBadgeVector key={i} defect={defect} />)}
    </View>;
};

